import { createSvgIcon } from '@mui/material'

export const ListIcon = createSvgIcon(
  <svg width='19' height='18' viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M18 15C18.55 15 19 15.45 19 16V17C19 17.55 18.55 18 18 18H1C0.45 18 0 17.55 0 17V16C0 15.45 0.45 15 1 15H18ZM18 5C18.55 5 19 5.45 19 6V12C19 12.55 18.55 13 18 13H1C0.45 13 0 12.55 0 12V6C0 5.45 0.45 5 1 5H18ZM18 0C18.55 0 19 0.45 19 1V2C19 2.55 18.55 3 18 3H1C0.45 3 0 2.55 0 2V1C0 0.45 0.45 0 1 0H18Z'
      fill='#637381'
    />
  </svg>,
  'ListIcon',
)
